import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
   0% {
      transform: rotate(0deg);
   }
   
   100% {
      transform: rotate(360deg);
   }
`;

const fadeIn = keyframes`
   0% {
      opacity: 0
   }

   50% {
      opacity: 0
   }
   
   100% {
      opacity: 1
   }
`;

const ElementLoading = styled.div`
   border-radius: 50%;
   width: 10em;
   height: 10em;
   margin: 60px auto;
   font-size: 10px;
   position: relative;
   text-indent: -9999em;
   border: 1.1em solid rgba(255, 154, 97, 0.2);
   border-left: 1.1em solid var(--brand-light-orange);
   transform: translateZ(0);
   animation: ${rotate} 0.9s infinite linear, ${fadeIn} 0.75s linear;

   &:after {
      border-radius: 50%;
      width: 10em;
      height: 10em;
   }
`;

export { ElementLoading };
